import React from "react";
import styles from "../KpiForm.module.sass";
import { DescriptionsLocales } from "../../../../components";

const DescriptionsTab = ({ KpiLabel, Description, handleChange }) => {
    return (
        <div>
            <div className={styles["group-content"]}>
                <DescriptionsLocales
                    handleChange={handleChange}
                    jsonObject={KpiLabel}
                    keyToChange={"KpiLabel"}
                    inputTitle={"Kpi Label"}
                    inputPlaceholder={"Enter a Kpi Label"}
                    containerTitle={"Kpi Labels"}
                />
                <DescriptionsLocales
                    handleChange={handleChange}
                    jsonObject={Description}
                    keyToChange={"Description"}
                    inputTitle={"Description"}
                    inputPlaceholder={"Enter a Description"}
                    containerTitle={"Descriptions"}
                />
            </div>
        </div>
    );
};

export default DescriptionsTab;
